import window from 'window';
import $ from 'rgs-jquery';

import Cookies from 'js-cookie';


import _ from 'lodash';

/*
 * Wrappers & helpers around `dataLayer.push(...)`
 */

const api = {};


let debug;

function Pusher (/* ...data */) {
	this._data = $.extend.apply(null, [{}, {}].concat([].slice.call(arguments)));

	// FIXME: из-за проблем с browserify, просто взять и заимпортить пакет debug нельзя, потому что
	// тогда debug выносится из конкретного бандла в common.js, где не может разрезолвить свои завимости 
	// и всё к чертям падает. Поэтому тут написан отличный костыль, чтобы выстрелить себе в ногу не сейчас,
	// а немножко позже
	if (!debug) {
		debug = require('debug');
	}

	this._debug =	debug;

	if (this._debug
			 && _.isFunction(this._debug.get)
			 && _.isNil(this._debug.get('gtm.consoleLog'))) {
		this._debug.define({
			gtm: {
				consoleLog: 'boolean',
			},
		});
	}
}
Pusher.prototype = {
	constructor: Pusher,

	_privateDataNamespace: '__Rgs.Utils.GoogleTagManager.Pusher.PrivateData',

	_privateData: function (key, val) {
		if (!this._data[this._privateDataNamespace]) {
			this._data[this._privateDataNamespace] = {};
		}
		if (arguments.length === 1) { // get
			return this._data[this._privateDataNamespace][key];
		} else if (arguments.length === 2) { // set
			this._data[this._privateDataNamespace][key] = val;
		}
	},

	push: function () {
		if (!window.dataLayer) {
			console.warn('pusher.push skipped due to undefined `dataLayer` global');
			return;
		}
		let data = $.extend({}, this._data);
		delete data[this._privateDataNamespace];

		// call every function and replace it with return value
		data = JSON.parse(JSON.stringify(data, function (k, v) {
			if ('function' === typeof v) {
				return v();
			}
			return v;
		}));

		window.dataLayer.push(data);
	
		if (this._debug
			&& _.isFunction(this._debug.get)
			&& this._debug.get('gtm.consoleLog')) {
			console.info(
				'dataLayer.push',
				data
			);
		}
	},

	extend: function (data) { // TODO: multiple args
		return new this.constructor(this._data, data);
	},

	event: function (evt) {
		return this.extend({event: evt});
	},
	category: function (cat) {
		return this.extend({eventCategory: cat});
	},
	action: function (act) {
		return this.extend({eventAction: act});
	},
	ecommerce: function (data) {
		return this.extend({ecommerce: data});
	},
};

function PusherOnce () {
	/*
	 * Like `Pusher`, but only does `dataLayer.push` only once (uses cookie to remember that)
	 */
	Pusher.apply(this, arguments);
}
PusherOnce.prototype = $.extend({}, Pusher.prototype, {
	constructor: PusherOnce,
	_setCookieParams: function (name, options = {}) {
		_.defaults(options, { expires: 365 });

		this._privateData('cookieParams', {
			name: name,
			options: $.extend({ path: '/' }, options),
		});
	},
	push: function () {
		const params = this._privateData('cookieParams');
		if (Cookies.get(params.name) === 'true') {
			return;
		}
		Pusher.prototype.push.apply(this, arguments);
		Cookies.set(params.name, 'true', params.options);
	},
});

function makeProductHelper (constantsId) {
	const consts = CONST.PRODUCTS[constantsId];
	return function (/* ...data */) {
		return $.extend.apply(null, [{
			id: consts.ID,
			name: consts.NAME,
			brand: consts.BRAND,
		}].concat([].slice.call(arguments)));
	};
}

const CONST = {
	PRODUCTS: {
		COMMON_AUTO: {
			NAME: 'rgsAutoinsurance',
			ID: 'Auto-insurance',
		},
		COMMON_TRAVEL: {
			NAME: 'rgsTravel',
			ID: 'Travel-insurance',
		},
		COMMON_HEALTH: {
			NAME: 'rgsPersonalAccident',
			ID: 'Health-insurance',
		},
	},
};
$.extend(true, CONST, {
	PRODUCTS: {
		OSAGO: $.extend({
			BRAND: 'OSAGO',
		}, CONST.PRODUCTS.COMMON_AUTO),
		KASKO: $.extend({
			BRAND: 'KASKO',
		}, CONST.PRODUCTS.COMMON_AUTO),
		TRAVEL: $.extend({
			BRAND: 'AWAY',
		}, CONST.PRODUCTS.COMMON_TRAVEL),
		RFTRAVEL: $.extend({
			BRAND: 'HOME',
		}, CONST.PRODUCTS.COMMON_TRAVEL),
		MITE: $.extend({
			BRAND: 'Insects',
		}, CONST.PRODUCTS.COMMON_HEALTH),
		FLAT: {
			NAME: 'rgsFlatInsurance',
			ID: 'Flat_insurance',
			BRAND: 'Flat',
		},
	},
});
$.extend(true, CONST, {
	PRODUCTS: {
		TRAVEL2: CONST.PRODUCTS.TRAVEL,
	},
});

$.extend(api, {
	CONST: CONST,
	pusher: function () {
		return new Pusher();
	},
	pusherOnce: function () {
		const pusher = new PusherOnce();
		pusher._setCookieParams(...arguments);
		return pusher;
	},
	products: {
		osago: makeProductHelper('OSAGO'),
		kasko: makeProductHelper('KASKO'),
		travel: makeProductHelper('TRAVEL'),
		rftravel: makeProductHelper('RFTRAVEL'),
		mite: makeProductHelper('MITE'),
		flat: makeProductHelper('FLAT'),
	},
});


$(function () {
	const event = api.pusher().event('productClick');

	// FIXME: will not work with dynamically inserted content
	// TODO: event deligation
	$('[data-gtm-button-for-product]').each(function () {
		const $this = $(this);

		const product = $this.attr('data-gtm-button-for-product');

		const pusher = event.ecommerce({
			'products': [api.products[product]({
				'quantity': 1,
			})],
		});

		$this.click(function () {
			pusher.push();
		});
	});
});

module.exports = api;

